import { useEffect, useState } from "react";

/**
 * True for typical phones (iPhone, Android with Mobile UA, etc.).
 * Excludes iPad so tablets behave closer to desktop for Drive links.
 */
export function isMobilePhone(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  if (/iPad/i.test(ua)) return false;
  return /iPhone|iPod|Android.*Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    ua,
  );
}

export function useIsMobilePhone(): boolean {
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    setMobile(isMobilePhone());
  }, []);
  return mobile;
}

const IOS_DRIVE_STORE =
  "https://apps.apple.com/app/google-drive/id507874739";
const ANDROID_DRIVE_STORE =
  "https://play.google.com/store/apps/details?id=com.google.android.apps.docs";

/** App Store on Apple devices, Play Store otherwise (typical Android phone). */
export function getGoogleDriveStoreUrl(): string {
  if (typeof navigator === "undefined") return ANDROID_DRIVE_STORE;
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/i.test(ua)) return IOS_DRIVE_STORE;
  return ANDROID_DRIVE_STORE;
}
